import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_SUB_AZURE,
  GET_SUB_AZURE_SUCCESS,
  GET_SUB_AZURE_ERROR,
} from "./constant";

import { getAzureSubApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureSubList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureSubApi, params, provider);
    yield put({ type: GET_SUB_AZURE_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_SUB_AZURE_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureSubSaga() {
  yield takeLatest(GET_SUB_AZURE, getAzureSubList);
}
